/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetInventoryOutSummaryQuery } from '../../models/get-inventory-out-summary-query';
import { GetInventoryOutSummaryQueryResult } from '../../models/get-inventory-out-summary-query-result';

export interface ApiNurseryManagerReportsGetInvOutSummaryReportPost$Params {
      body?: GetInventoryOutSummaryQuery
}

export function apiNurseryManagerReportsGetInvOutSummaryReportPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerReportsGetInvOutSummaryReportPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetInventoryOutSummaryQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerReportsGetInvOutSummaryReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetInventoryOutSummaryQueryResult>;
    })
  );
}

apiNurseryManagerReportsGetInvOutSummaryReportPost.PATH = '/api/NurseryManager/Reports/GetInvOutSummaryReport';
